import { render, staticRenderFns } from "./CustomerModify.vue?vue&type=template&id=3b2776f2&scoped=true"
import script from "./CustomerModify.vue?vue&type=script&lang=js"
export * from "./CustomerModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2776f2",
  null
  
)

export default component.exports